module.exports = __webpack_public_path__ + "static/media/swipe.609bb2d0.gif";